import React from "react";
import { Box } from "@mui/material";

// Template184: Página de Transporte - Consejos para moverse por Kioto
// Copia DIRECTA del componente Subway.jsx de guia-kioto, adaptado para usar las props del sistema guia
const Template184 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const isSmallScreen = window.innerWidth <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText = page?.texts?.[0]?.content;
	const busSticker = getImageSrc("metro-main");

	const pageOrder =
		page?.order !== undefined
			? page.order
			: page?.data?.order !== undefined
			? page.data.order
			: -1;
	const isTokioGuide = headerBackgroundColor === "#24221a";
	const actualHeaderColor =
		isTokioGuide && pageOrder > 0
			? "#e24217"
			: headerBackgroundColor || "#5ba374";

	const introText = page?.texts?.[1]?.content;
	const section1Title = page?.texts?.[2]?.content;
	const section1Content = page?.texts?.[3]?.content;
	const section2Title = page?.texts?.[4]?.content;
	const section2Content = page?.texts?.[5]?.content;
	const tipText = page?.texts?.[6]?.content;
	const tarjetasText = page?.texts?.[7]?.content;
	const consejoTitle = page?.texts?.[8]?.content;
	const consejoText = page?.texts?.[9]?.content;

	const isFromPage = section1Title != null && section1Content != null;
	const autobusesTitle = section1Title;
	const autobusesText1 = section1Content;
	const trenTitle = section2Title;
	const trenText1 = section2Content;

	// Estilos
	const h3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		marginBottom: "12px",
		marginTop: 0,
	};

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
			height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "10px !important",
				},
			}}
		>
			{/* CABECERA */}
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 1053,
					}}
				>
					{headerText}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "12px 16px", fontSize: "13px", color: "#444" }}>
					{introText.includes("<") ? (
						<Box component="p" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }} dangerouslySetInnerHTML={{ __html: introText }} />
					) : (
						<Box component="p" sx={{ ...p, margin: "0 !important", marginBottom: "0px !important" }}>{introText}</Box>
					)}
				</Box>
			)}

			{/* TRANSPORTES */}
			<Box data-block-id="text-2" sx={{ padding: "0 16px", fontSize: "13px", color: "#444" }}>
				{autobusesTitle && (
					<Box component="h3" sx={h3}>
						{autobusesTitle}
					</Box>
				)}
				{autobusesText1 && (
					<Box
						component="div"
						sx={{ ...p, margin: 0 }}
						dangerouslySetInnerHTML={{ __html: autobusesText1 }}
					/>
				)}

				{trenTitle && (
					<Box component="h3" sx={h3}>
						{trenTitle}
					</Box>
				)}
				{trenText1 && (
					<Box
						component="div"
						sx={{ ...p, margin: 0 }}
						dangerouslySetInnerHTML={{ __html: trenText1 }}
					/>
				)}
			</Box>

			{tarjetasText && (
				<Box
					data-block-id="text-3"
					sx={{
						backgroundColor: "#fff8db",
						border: "2px solid #f5c400",
						borderRadius: "12px",
						padding: "10px 12px",
						margin: "16px",
						marginTop: "4px",
						fontSize: "12px",
						color: "#444",
					}}
				>
					<Box dangerouslySetInnerHTML={{ __html: tarjetasText }} />
				</Box>
			)}

			{(consejoTitle || consejoText) && (
				<Box data-block-id="text-4" sx={{ padding: "12px", paddingTop: 0 }}>
					<Box
						sx={{
							backgroundColor: "#e0f2e8",
							border: "3px solid #5ba374",
							borderRadius: "16px",
							padding: "16px",
							position: "relative",
							width: isSmallScreen ? "100%" : "100%",
						}}
					>
						{consejoTitle && (
							<Box component="h3" sx={{ ...h3, color: "#3d805e" }}>
								{consejoTitle}
							</Box>
						)}
						{consejoText && (
							<Box
								component="ul"
								sx={{ paddingLeft: "18px", margin: 0, fontSize: "13px" }}
							>
								<Box component="li" sx={{ ...p, margin: 0 }}>
									{consejoText}
								</Box>
							</Box>
						)}
					</Box>
				</Box>
			)}
			{(busSticker || tipText) && (
				<Box data-block-id="text-5" sx={{ position: "relative" }}>
					{busSticker && (
						<Box
							component="img"
							src={busSticker}
							alt="bus kyoto"
							sx={{
								width: 100,
								position: "absolute",
								bottom: isSmallScreen ? "-90px" : "-120px",
								right: isSmallScreen ? "20px" : "20px",
							}}
						/>
					)}
					{tipText && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? "-70px" : "-80px",
								right: isSmallScreen ? "100px" : "100px",
								backgroundColor: "#fff8db",
								border: "2px solid #f5c400",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: "11px",
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 200,
							}}
						>
							{tipText.includes("<") ? <span dangerouslySetInnerHTML={{ __html: tipText }} /> : tipText}
						</Box>
					)}
				</Box>
			)}
		</Box>
	);
};

Template184.thumbnail = "/images/template-1.png";

export default Template184;
